<template>
  <svg class="circular" :height="diameter" :width="diameter" :stroke="color">
    <circle
      class="circular__path"
      :cx="diameter / 2"
      :cy="diameter / 2"
      :r="diameter / 2.5"
      fill="none"
      :stroke-width="strokeWidth"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script>
export default {
  props: {
    diameter: {
      type: Number,
      default: 20,
    },
    strokeWidth: {
      type: Number,
      default: 2,
    },
    color: {
      type: String,
      // TODO change it to dynamic primary color
      default: '#fdd500', // --emcd
    },
  },
}
</script>

<style lang="scss" scoped>
.circular {
  @apply flex;
  animation: rotate 2s linear infinite;
  &__path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation:
      dash 1.5s ease-in-out infinite,
      color 6s ease-in-out infinite;
    stroke-linecap: round;
  }
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
}
</style>
